/** 
 * desc 订单分享页状态码
 */
export const ORDER_STATE_MAP =  {
  error: -1, // 接口、页面异常兜底
  going: 1, // 订单进行中
  cancel: 2, // 订单取消
  complete: 3, // 订单完成
}

/**
 * @desc 分享订单状态码
 * @wiki http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=807484088
 */
export const ORDER_STATUS = {
  FLASH_D_TAKEN: 1400, // 骑手送货中 （开始配送）
  FLASH_D_ARRIVED_DESTINATION: 1500,// 骑手到达终点 （待签收）
  FLASH_D_RETURN: 1600, // 骑手送回
  FLASH_FINISH: 1800, // 正常完单 （完成态）
  FLASH_ABNORMAL: 1900, // 异常取消完单 （取消态）
}
